module.exports = __webpack_public_path__ + "static/media/product4.b29ae79e.webp";